import React, { useEffect, useState } from "react";

import {
    IconButton,
    Box,
    Dialog,
    DialogTitle,
    Typography,
    makeStyles,
    DialogActions,
    Button,
}
from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';

import functionalitiesService, {funcionalidades} from 'src/services/functionalitiesService';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        borderRadius: "25px",
    },

    imgModal: {
        maxHeight: "400px",
        height: "auto",
        borderRadius: "24px",
    },

    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },  
    closeButtonText: {
        borderRadius: '24px',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        // Gris Claro
        '&:hover': {
          backgroundColor: '#1C73FE',
        },
        padding: '10px 30px',
        width: '100%',
        fontSize: '16px',
        fontWeight: 'bold',
    },
}));


function HomeDialogMessage({...props}) {

    const img_popup_url = "https://estatico.cabal.coop.py/public/dimo/flyers/main_page_modal.jpg";

    const classes = useStyles();

    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const mostrarMsgDialog = () => {
        functionalitiesService.funcionalidadHabilitada({codigo: funcionalidades.LANDPAGE_MSGMODAL.key})
        .then((response) => {
          
          if (response === true)
          {
            setOpen(true);
          }
        })
        .catch(()=> {
        })
    }

    useEffect(() => {
        mostrarMsgDialog();
    }, [])


    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} className={classes.root}         
        PaperProps={{
          style: {
            borderRadius: '24px',
            padding: '5px',
          },
        }}>
            <DialogTitle id="simple-dialog-title" style={{display:"none"}}>
                
                <Typography  variant="h3" color="primary">
                    {'DIMO'}
                </Typography>
                
                <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>    
                    <CloseIcon />
                </IconButton>
                
            </DialogTitle>

            <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>    
                <CloseIcon />
            </IconButton>

            <Box style={{padding:"2px", borderRadius:"24px"}}
            >
                <img src={img_popup_url} className={classes.imgModal}></img>
            </Box>
            <DialogActions>
                <Button onClick={handleClose} color="primary" className={classes.closeButtonText}>
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default HomeDialogMessage;